import { LoaderFunctionArgs } from "react-router-dom";
import { store } from "../../store";
import { getAllPushMessage } from "../../actions/push-message";
import { resetPushMessage } from "../reducers/push-message.reducer";

export const pushMessageLoader = async (args: LoaderFunctionArgs) => {
  store.dispatch(resetPushMessage());

  return await getAllPushMessage();
};
